import React, { Component } from 'react';
import TableRow from './TableRow.jsx';

class TableBody extends Component {
    constructor(props) {
        super(props);        
    }
    render() {
        let modifiedLimits = this.props.modifiedLimits;
        return (
            <tbody>
                {modifiedLimits.map((modifiedLimit, i) =>
                    <TableRow modifiedLimit={modifiedLimit} key={"modifiedLimit_" + i} />
                )}
            </tbody>
        );
    }
}
export default TableBody;